module.exports = __webpack_public_path__ + "static/media/physical.9132b1d6.png";